import React, { useEffect, useState, useCallback } from 'react'
import { Image } from 'antd';
import moment from "moment";
import { ImageUrl } from '../../ApiServices/ApiServices';
import Loader from '../../Pages/Component/Loader';
import { useNavigate } from 'react-router-dom';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { get } from '../../ApiServices/ApiServices';
import { useSelector } from 'react-redux';
import Select from "react-select";
function RecentOrdersTab() {
    const [recentCurrentPage, setRecentCurrentPage] = useState(1);
    const profile = useSelector((state) => state.profile.profile);
    const isAdmin = profile?.name === "Admin";
    const FILTER_STORAGE_KEY = "recentOrdersFilters";
    const savedFilters = isAdmin
        ? JSON.parse(sessionStorage.getItem(FILTER_STORAGE_KEY)) || {}
        : {};

    const [recentTotalItems, setRecentTotalItems] = useState(0);
    const [recentItemsPerPage, setRecentItemsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [RecentOrders, setRecentOrders] = useState([])
    const [recentOrdersLoading, setRecentOrdersLoading] = useState(false); // New loader state for recent orders
    const [displayLabel, setDisplayLabel] = useState(savedFilters.displayLabel || "");
    const [Status, setStatus] = useState([]);
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [orderStatusFilter, setOrderStatusFilter] = useState(savedFilters.orderStatusFilter || "");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

    const [customerList, setCustomerList] = useState([]);
    const [accountFilter, setAccountFilter] = useState(savedFilters.accountFilter || "");
    const userAccount = useSelector((state) => state.profile.profile?.account);


    const [orderTypeFilter, setOrderTypeFilter] = useState(savedFilters.orderTypeFilter || "");
    const [orderDateRange, setOrderDateRange] = useState(savedFilters.orderDateRange || {
        startDate: "",
        endDate: "",
    });
    const [orderDateLabel, setOrderDateLabel] = useState(savedFilters.orderDateLabel || "");
    const getCustomers = async () => {
        try {
            const response = await get(`get-customers`);

            if (response?.status === true) {
                setCustomerList(response?.data?.rows || []);
            }
        } catch (err) {
            console.error("Customer fetch error:", err);

            if (
                err?.message === "Invalid or expired token" ||
                err?.message === "Invalid Token"
            ) {
                localStorage.removeItem("token");
                navigate("/login");
            }
        }
    };
    const RecentOrder = async () => {
        try {
            setRecentOrdersLoading(true); // Use specific loader for recent orders
            let api = `recent-orders?search=${debouncedSearchTerm || ""}&page_number=${recentCurrentPage}&size=${recentItemsPerPage}`;

            if (dateRange?.startDate && moment(dateRange.startDate).isValid()) {
                api += `&start_date=${moment(dateRange.startDate).format('YYYY-MM-DD')}`;
            }

            if (dateRange?.endDate && moment(dateRange.endDate).isValid()) {
                api += `&end_date=${moment(dateRange.endDate).format('YYYY-MM-DD')}`;
            }

            if (orderStatusFilter) {
                api += `&order_status=${orderStatusFilter}`;
            }
            if (orderTypeFilter) {
                api += `&order_type=${orderTypeFilter}`;
            }

            if (orderDateRange?.startDate) {
                api += `&order_start_date=${moment(orderDateRange.startDate).format('YYYY-MM-DD')}`;
            }

            if (orderDateRange?.endDate) {
                api += `&order_end_date=${moment(orderDateRange.endDate).format('YYYY-MM-DD')}`;
            }

            if (accountFilter) {
                api += `&account=${accountFilter}`;
            }

            const response = await get(api);
            if (response?.status == true) {
                if (isAdmin) {
                    setRecentOrders(response?.data?.rows)
                    setRecentTotalItems(response?.data?.count || 0);

                }
                else {
                    const userOrders = response?.data?.rows?.filter(order =>
                        order?.account === userAccount
                    );
                    setRecentOrders(userOrders || []);
                    setRecentTotalItems(userOrders?.length || 0);
                }
            }
        } catch (err) {
            console.error('Error:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
            setRecentOrdersLoading(false); // Turn off specific loader
        }
    };



    const ActiveStatus = async () => {
        try {
            const api = `get-statuses`;
            const response = await get(api);
            if (response?.message === "success") {
                setStatus(response?.data)
            }
        } catch (err) {
            console.error('Error:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
        }
    };

    useEffect(() => {
        ActiveStatus()
        getCustomers();
    }, [])

    const orderStatuses = [
        { value: '', label: 'All Statuses' },
        { value: 'ordered', label: 'Ordered' },
        { value: 'changed', label: 'Changed' },
        { value: 'bagged', label: 'Bagged' },
        { value: 'shipped', label: 'Shipped' },
        { value: 'delivered', label: 'Delivered' }
    ];
    const debounce = (func, delay) => {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const handleOrderStatusChange = (e) => {
        setOrderStatusFilter(e.target.value);
        setRecentCurrentPage(1);
    };

    const onDateChange = (dates) => {
        if (dates.startDate && dates.endDate) {
            setDateRange({
                startDate: dates.startDate,
                endDate: dates.endDate
            });
        } else {
            setDateRange({
                startDate: null,
                endDate: null
            });
        }
        setCurrentPage(1);
    };
    const handleOrderTypeChange = (e) => {
        setOrderTypeFilter(e.target.value);
        setRecentCurrentPage(1);
    };

    const handleOrderDateApply = (event, picker) => {
        const startDate = picker.startDate;
        const endDate = picker.endDate;

        setOrderDateRange({
            startDate,
            endDate
        });

        setOrderDateLabel(`${startDate.format('MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`);

        setRecentCurrentPage(1);
    };

    const handleOrderDateCancel = () => {
        setOrderDateRange({
            startDate: null,
            endDate: null,
        });
        setOrderDateLabel('');
        setRecentCurrentPage(1);
    };


    const recentTotalPages = Math.ceil(recentTotalItems / recentItemsPerPage);


    const [dateRange, setDateRange] = useState(savedFilters.dateRange || {
        startDate: "",
        endDate: "",
    });

    const handleApply = (event, picker) => {
        const startDate = picker.startDate;
        const endDate = picker.endDate;

        setDateRange({ startDate, endDate });
        setDisplayLabel(`${startDate.format('MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`);

        if (onDateChange) {
            onDateChange({
                startDate: startDate.format('YYYY-MM-DD'),
                endDate: endDate.format('YYYY-MM-DD')
            });
        }
    };

    const handleRecentItemsPerPageChange = (e) => {
        const newLimit = parseInt(e.target.value);
        setRecentItemsPerPage(newLimit);
        setRecentCurrentPage(1);
    };


    const handleCancel = (event, picker) => {
        setDateRange({
            startDate: null,
            endDate: null,
        });
        setDisplayLabel('');
        setDateRange({
            startDate: null,
            endDate: null
        });

        if (picker) {
            picker.setStartDate(moment());
            picker.setEndDate(moment());
            picker.updateView();
        }
    };

    const handleSearchDebounced = useCallback(
        debounce((value) => {
            setDebouncedSearchTerm(value);
            setCurrentPage(1);
        }, 500),
        []
    );

    useEffect(() => {
        if (isAdmin) {
            const filters = {
                accountFilter,
                orderTypeFilter,
                orderStatusFilter,
                dateRange,
                displayLabel,
                orderDateRange,
                orderDateLabel
            };

            sessionStorage.setItem(
                FILTER_STORAGE_KEY,
                JSON.stringify(filters)
            );
        }
    }, [
        accountFilter,
        orderTypeFilter,
        orderStatusFilter,
        dateRange,
        displayLabel,
        orderDateRange,
        orderDateLabel
    ]);

    useEffect(() => {
        if (!isAdmin) {
            sessionStorage.removeItem(FILTER_STORAGE_KEY);
        }
    }, [isAdmin]);

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        handleSearchDebounced(value);
    };
    useEffect(() => {
        RecentOrder();
    }, [debouncedSearchTerm,
        dateRange,
        orderStatusFilter,
        orderTypeFilter,
        orderDateRange,
        recentCurrentPage,
        recentItemsPerPage,
        accountFilter]);
    return (
        <>
            <div className="row align-items-center justify-content-between">
                <div className="col-md-6">
                    <h5>Recent Orders</h5>
                </div>
            </div>
            <div className="card-title-group mb-3 stateSelect">
                <div className="card-tools" style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                    <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                            <em className="icon ni ni-search"></em>
                        </div>
                        <input
                            type="text"
                            className="form-control common-filter-input"
                            placeholder="Search by Account# or Order#"
                            value={searchTerm}
                            onChange={handleSearch}
                            disabled={recentOrdersLoading}
                        />

                    </div>
                    <div className="form-control-wrap">
                        <DateRangePicker
                            initialSettings={{
                                startDate: dateRange.startDate || moment(),
                                endDate: dateRange.endDate || moment(),
                                locale: {
                                    format: 'MMM D, YYYY',
                                    cancelLabel: 'Clear',
                                    applyLabel: 'Apply',
                                },
                                ranges: {
                                    'Today': [moment(), moment()],
                                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                                },
                                opens: 'right',
                                autoApply: true,
                                autoUpdateInput: true,
                                alwaysShowCalendars: true,
                                showCustomRangeLabel: true,
                                showCancel: true,
                            }}
                            onApply={handleApply}
                            onCancel={handleCancel}
                        >
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Select Weekend date range"
                                value={displayLabel}
                                readOnly
                                style={{
                                    cursor: 'pointer',
                                    backgroundColor: '#fff',
                                    border: '1px solid #dbdfea',
                                    borderRadius: '4px',
                                    padding: '0.375rem 0.75rem',
                                    minWidth: '250px',
                                    paddingRight: '30px',
                                    color: '#35495e',
                                }}
                            />
                        </DateRangePicker>
                        {displayLabel && (
                            <span
                                className="clear-icon"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    const cancelBtn = document.querySelector('.daterangepicker .cancelBtn');
                                    if (cancelBtn) {
                                        cancelBtn.click();
                                    } else {
                                        handleCancel();
                                    }
                                }}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    zIndex: 10
                                }}
                            >
                                <em className="icon ni ni-cross"></em>
                            </span>
                        )}
                    </div>
                    <div className="form-control-wrap">
                        <DateRangePicker
                            initialSettings={{
                                startDate: orderDateRange.startDate || moment(),
                                endDate: orderDateRange.endDate || moment(),
                                locale: {
                                    format: 'MMM D, YYYY',
                                    cancelLabel: 'Clear',
                                    applyLabel: 'Apply',
                                },
                                ranges: {
                                    'Today': [moment(), moment()],
                                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                                },
                                opens: 'right',
                                autoApply: true,
                                autoUpdateInput: true,
                                alwaysShowCalendars: true,
                                showCustomRangeLabel: true,
                                showCancel: true,
                            }}
                            onApply={handleOrderDateApply}
                            onCancel={handleOrderDateCancel}
                        >
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Filter by Order Date"
                                value={orderDateLabel}
                                readOnly
                                style={{
                                    cursor: 'pointer',
                                    backgroundColor: '#fff',
                                    border: '1px solid #dbdfea',
                                    borderRadius: '4px',
                                    padding: '0.375rem 0.75rem',
                                    minWidth: '250px',
                                    paddingRight: '30px',
                                    color: '#35495e',
                                }}
                            />
                        </DateRangePicker>

                        {orderDateLabel && (
                            <span
                                className="clear-icon"
                                onClick={handleOrderDateCancel}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    zIndex: 10
                                }}
                            >
                                <em className="icon ni ni-cross"></em>
                            </span>
                        )}
                    </div>

                    <div className="form-control-wrap">
                        <Select
                            className="basic-single"
                            classNamePrefix="select"
                            placeholder="Filter by Active Status"
                            isClearable
                            options={[
                                { value: "", label: "All" },
                                ...Status.map((data) => ({
                                    value: data.name,
                                    label: data.name
                                }))
                            ]}
                            value={
                                orderStatusFilter
                                    ? { value: orderStatusFilter, label: orderStatusFilter }
                                    : null
                            }
                            onChange={(selectedOption) => {
                                handleOrderStatusChange({
                                    target: { value: selectedOption?.value || "" }
                                });
                            }}

                            menuPortalTarget={document.body}
                        />
                    </div>

                    <div className="form-control-wrap">
                        <Select
                            className="basic-single"
                            classNamePrefix="select"
                            placeholder="Filter by Order Type"
                            isClearable
                            options={[
                                { value: "", label: "All" },
                                { value: "Single Order", label: "Single Order" },
                                { value: "Prom Order", label: "Prom Order" },
                                { value: "Funeral Order", label: "Funeral Order" },
                                { value: "T", label: "T" },
                                { value: "Wedding Order", label: "Wedding Order" }
                            ]}
                            value={
                                orderTypeFilter
                                    ? { value: orderTypeFilter, label: orderTypeFilter }
                                    : null
                            }
                            onChange={(selectedOption) => {
                                handleOrderTypeChange({
                                    target: { value: selectedOption?.value || "" }
                                });
                            }}

                            menuPortalTarget={document.body}
                        />
                    </div>

                    {
                        isAdmin &&
                        <div className="form-control-wrap">
                            <Select
                                className="basic-single"
                                classNamePrefix="select"
                                placeholder="Filter by Account"
                                isClearable
                                maxMenuHeight={280}
                                menuPlacement="auto"
                                menuPosition="fixed"
                                menuPortalTarget={document.body}
                                options={customerList?.map((item) => ({
                                    value: item?.account,
                                    label: `${item?.account} ${item?.companyName ? `- ${item?.companyName}` : ""
                                        }`
                                }))}
                                value={
                                    accountFilter
                                        ? {
                                            value: accountFilter,
                                            label: accountFilter
                                        }
                                        : null
                                }
                                onChange={(selectedOption) => {
                                    setAccountFilter(selectedOption?.value || "");
                                    setRecentCurrentPage(1);
                                }}

                            />
                        </div>
                    }

                </div>
            </div>
            <div className="row mt-3">
                <div className="col-md-12">
                    {recentOrdersLoading ? (
                        <div className="text-center py-4">

                            <Loader />                                                         </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">Account #</th>
                                        <th scope="col">Order # </th>
                                        <th scope="col">Type</th>
                                        <th scope="col">Style Photo</th>
                                        <th scope="col">Style Name</th>
                                        <th scope="col">Order Date</th>
                                        <th scope="col">Customer Name</th>
                                        <th scope="col">Event Date</th>
                                        <th scope="col">Week Ending Date</th>

                                        <th scope="col">Order Status</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {RecentOrders && RecentOrders.length > 0 ? (
                                        RecentOrders.map((data) => (
                                            <tr key={data?.order_id}>
                                                <td className="tableMinWidth120" scope="row">{data?.account}</td>
                                                <td className="tableMinWidth120" scope="row">{data?.ticket}</td>
                                                <td className="tableMinWidth120" scope="row">{data?.order_type}</td>
                                                <td className="tableMinWidth120">
                                                    <Image
                                                        src={data?.item_photo ? `${ImageUrl}${data?.item_photo}` : "assets/images/no-photo.png"}
                                                        alt=""
                                                        height={50}
                                                        width={40}
                                                    />
                                                </td>
                                                <td className="tableMinWidth1550">{data?.product_name} {data?.product_description}</td>
                                                <td className="tableMinWidth120"> {data?.is_csv ? moment.utc(data?.order_creation).format("MMM D, YYYY") : moment.utc(data?.order_date).format("MMM D, YYYY")}</td>
                                                <td className="tableMinWidth1550">{data?.customer_name}</td>
                                                <td className="tableMinWidth120">{moment.utc(data?.event_date).format("MMM D, YYYY")}</td>
                                                <td>
                                                    {(() => {
                                                        const eventDate = moment.utc(data?.event_date);
                                                        const currentDay = eventDate.isoWeekday(); // 1=Mon ... 7=Sun

                                                        if (currentDay === 7) return eventDate.clone().subtract(1, "day").format("MMM D, YYYY"); // Sunday → Previous Saturday
                                                        if (currentDay === 1) return eventDate.clone().subtract(2, "days").format("MMM D, YYYY"); // Monday → Previous Saturday
                                                        if (currentDay === 6) return eventDate.format("MMM D, YYYY"); // Saturday → Current
                                                        return eventDate.clone().isoWeekday(6).format("MMM D, YYYY"); // Tue–Fri → Upcoming Saturday
                                                    })()}
                                                </td>
                                                <td >
                                                    <span className="badge openBadge text-capitalize font-revert bg-warning">
                                                        {data?.order_status}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="tableActionBtn-1" style={{ cursor: "pointer" }}>
                                                        <button
                                                            className="editPen"
                                                            onClick={() => {
                                                                if (data?.created_for == "Single Order") {
                                                                    navigate('/order-detail', { state: { orderId: data?.order_id } });
                                                                } else {
                                                                    navigate('/Member-detail', { state: { eventId: data?.order_id } });
                                                                }
                                                            }}
                                                        >
                                                            <em className="icon ni ni-eye"></em>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="11" className="text-center py-3">
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>
                    )}




                </div>

            </div>
            {RecentOrders.length > 0 && recentTotalPages > 1 && (
                <div
                    className="nk-block-between-md g-2 mt-1"
                    style={{
                        minHeight: "auto",
                        paddingBottom: "10px"
                    }}
                >
                    <div className="g">
                        <div className="pagination d-flex gap-2" style={{ height: 'auto' }}>

                            <button
                                className="btn btn-primary"
                                disabled={recentCurrentPage === 1}
                                onClick={() => setRecentCurrentPage(recentCurrentPage - 1)}
                            >
                                Previous
                            </button>

                            {Array.from({ length: recentTotalPages }, (_, i) => (
                                <button
                                    key={i + 1}
                                    className={`btn ${recentCurrentPage === i + 1
                                        ? "btn-primary"
                                        : "btn-outline-primary"
                                        }`}
                                    onClick={() => setRecentCurrentPage(i + 1)}
                                >
                                    {i + 1}
                                </button>
                            )).slice(
                                Math.max(0, recentCurrentPage - 3),
                                Math.min(recentCurrentPage + 2, recentTotalPages)
                            )}

                            <button
                                className="btn btn-primary"
                                disabled={recentCurrentPage === recentTotalPages}
                                onClick={() => setRecentCurrentPage(recentCurrentPage + 1)}
                            >
                                Next
                            </button>

                        </div>
                    </div>

                    {recentTotalItems > 0 && (
                        <div className="g">
                            <div className="pagination-goto d-flex justify-content-center justify-content-md-start gx-3">
                                <div>Showing</div>
                                <div>
                                    <select
                                        className="form-select js-select2"
                                        value={recentItemsPerPage}
                                        onChange={handleRecentItemsPerPageChange}
                                    >
                                        {recentTotalItems >= 10 && <option value="10">10</option>}
                                        {recentTotalItems >= 20 && <option value="20">20</option>}
                                        {recentTotalItems >= 50 && <option value="50">50</option>}
                                        {recentTotalItems >= 100 && <option value="100">100</option>}
                                    </select>
                                </div>
                                <div>of {recentTotalItems} items</div>
                            </div>
                        </div>
                    )}
                </div>
            )}

        </>
    )
}

export default RecentOrdersTab;
